import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import styles from "../../AdminDashboard/contentComponents/allAssessments.module.css";

const AssessmentTable = () => {
  const [assessments, setAssessments] = useState([]);
  const [loading, setLoading] = useState(true);
  const { assessmentId } = useParams(); // Extracting assessmentId from the URL

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [allQuestions, setAllQuestions] = useState([]);

  useEffect(() => {
    console.log("assessmentId:", assessmentId);
    const fetchData = async () => {
      try {
        const response = await axios.post('https://casaahaanahotels.com/print_assessment', {
          assessmentid: assessmentId // Use assessmentId from URL params
        });
        setAssessments(response.data.result);
        // Flatten all questions for pagination
        const questions = [];
        response.data.result.forEach((assessment) => {
          if (assessment._source && Array.isArray(assessment._source.assessmentquestion)) {
            assessment._source.assessmentquestion.forEach((question) => {
              questions.push(question);
            });
          }
        });
        setAllQuestions(questions);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [assessmentId]);

  // When assessments change, reset to first page
  useEffect(() => {
    setCurrentPage(1);
  }, [assessments.length]);

  // Pagination logic
  const totalPages = Math.ceil(allQuestions.length / itemsPerPage);
  const paginatedQuestions = allQuestions.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Helper to generate pagination numbers with ellipsis
  const getPagination = () => {
    const pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, 4, '...', totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
      }
    }
    return pages;
  };

  const handlePageClick = (page) => {
    if (page === '...') return;
    setCurrentPage(page);
  };

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  return (
    <div>
      <h2 style={{ textAlign: "center" }}>Assessment Data</h2>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className={styles.tableWrapper}>
          <table className={styles.assessmentTable}>
            <thead>
              <tr>
                <th>Question (Skill)</th>
                <th>Question (Behaviour)</th>
                <th>Driver Answer</th>
                <th style={{ width: '100px', maxWidth: '100px', textAlign: 'center' }}>Point</th>
              </tr>
            </thead>
            <tbody>
              {paginatedQuestions.map((question, idx) => {
                let skillColorClass = '';
                let behaviourColorClass = '';
                let Question_ans = '';

                if (question.Skills === question.Answer) {
                  skillColorClass = '#f2f2f2'; // Change background color for point 1
                } else if (question.Behaviour === question.Answer) {
                  behaviourColorClass = '#f2f2f2'; // Change background color for point 5
                }

                if (question.Skills === question.Answer) {
                  Question_ans = question.Question_skill;
                } else if (question.Behaviour === question.Answer) {
                  Question_ans = question.Question_behaviour;
                }

                return (
                  <tr key={idx} style={{ backgroundColor: "#ffffff", borderBottom: "1px solid #ccc", }}>
                    <td style={{ background: skillColorClass, whiteSpace: 'normal', overflow: 'visible', textOverflow: 'unset' }}>{question.Question_skill || question.Question_skill}</td>
                    <td style={{ background: behaviourColorClass, whiteSpace: 'normal', overflow: 'visible', textOverflow: 'unset' }}>{question.Question_behaviour || question.Question_behaviour}</td>
                    <td style={{ whiteSpace: 'normal', overflow: 'visible', textOverflow: 'unset' }}>{Question_ans}</td>
                    <td >{question.Point}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {/* Pagination Controls */}
          {totalPages > 1 && (
            <div className={styles.pagination} style={{ marginTop: '16px', display: 'flex', gap: '8px', alignItems: 'center', justifyContent: 'center' }}>
              <button onClick={handlePrev} disabled={currentPage === 1} className={styles.pageButton}>Prev</button>
              {getPagination().map((page, idx) => (
                <button
                  key={idx}
                  onClick={() => handlePageClick(page)}
                  disabled={page === '...'}
                  className={
                    page === currentPage
                      ? styles.activePageButton
                      : styles.pageButton
                  }
                  style={{ minWidth: 32 }}
                >
                  {page}
                </button>
              ))}
              <button onClick={handleNext} disabled={currentPage === totalPages} className={styles.pageButton}>Next</button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AssessmentTable;
